
export enum OrderStatus {
    ReadyToStage = 1,
    ReadyToShip = 2,
    Shipped = 3,
}

export enum OrderTypePrefix {
    Pickup = "PU",
    Delivery = "DL"
}

export enum OrderStaggingType {
    Pickup = "pickup",
    Delivery = "delivery"
}

export enum StorageKey {
    Events = "events",
    AgentInfo = "agentInfo",
    DataSet = "dataSet",
    RefreshAgrisLicense = "RefreshAgrisLicense",
    UserData = "userData",
    WarehouseProUserSelectedLocations = "WarehouseProUserSelectedLocations"
}

export enum AgentType {
    PSQL = "PSQL",
    MSQL = "SQL"
}


export enum WarehouseStaggingStatus {
    ReadyToStage = "1",
    InStaging = "2",
    Staged = "3",
    InDelivery = "4",
    Delivered = "5",
    InPickup = "6",
    Shipped = "7",
    Loaded = "8",
    UnLoaded = "9",
    StockAddtionCompleted = "20"
}


export enum ContractStatusNames {
    Unsent = "Unsent",
    ManuallySignedAndCompleted = "ManuallySignedAndCompleted",
    ReadyToSend = "Ready To Send",
    Sent = "Sent",
    Signed = "Signed",
    SignedAndComplete = "Signed and Complete",
    NotComplete = "Not Complete",
    Trashed = "Trashed",
    ErrorFromEsign = "Error From Esign",
    Deleted = "Deleted",
}

// export enum StuckedContactTypes {
//     InboundContract = 1,
//     OutBoundCOntract = 2
// }

export enum StuckedContractTypes{
    Default = "0",
    Inbound = "1",
    Outbound = "2"
}
